import styled from "styled-components";

export const Wrapper = styled.div`
  font-size: 2rem;
  color: inherit;
  font-weight: 900;
  padding: 1.5rem 0;
`;
